import { unreadCount } from '../state/widget';
import { t } from '../i18n';
import { ChatBubbleIcon, CloseIcon } from './Icons';

type Props = {
  open: boolean;
  onClick: () => void;
};

export function FloatingButton({ open, onClick }: Props) {
  const count = unreadCount.value;
  return (
    <button
      type="button"
      class="sw-fab"
      aria-label={open ? t('common.close') : t('fab.label')}
      onClick={onClick}
    >
      {!open ? <span class="sw-fab-pulse" aria-hidden="true" /> : null}
      {open ? <CloseIcon /> : <ChatBubbleIcon />}
      {!open && count > 0 ? <span class="sw-fab-badge">{count}</span> : null}
    </button>
  );
}
